import { useIntl } from 'react-intl'

import { storeGet } from 'mailup-react-helpers'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import { selectDayCallback } from 'Pages/ScheduledSendings/recoil/callbacks/callbacks'
import { calendarState } from 'Pages/ScheduledSendings/recoil/state/calendar'

import {
  Calendar,
  CalendarCell,
  CalendarHeaderCell,
  CalendarToolbar
} from 'Components/Calendar'

import { STORE_KEY_USER_LISTS } from 'Constants/'

import { FlexItem } from 'mailup-web-components'
import CalendarDayContent from './CalendarDayContent'
import CalendarNav from './CalendarNav'
import ListFilter from './ListFilter'
import ListTimezone from './ListTimezone'

const CalendarView = () => {
  const intl = useIntl()
  const { days, selectedDay } = useRecoilValue(calendarState)
  const userLists = storeGet(STORE_KEY_USER_LISTS)

  const handleDayClick = useRecoilCallback(selectDayCallback, [])

  return (
    <>
      <CalendarToolbar>
        <CalendarNav />
        <FlexItem flexGrow='1' />
        {userLists.length > 1 && (
          <FlexItem margin='0 40px 0 0'>
            <ListFilter />
          </FlexItem>
        )}
        <ListTimezone />
      </CalendarToolbar>
      <Calendar>
        <CalendarHeaderCell>
          {intl.formatMessage({ id: 'Load.MailupCommon.Sunday' })}
        </CalendarHeaderCell>
        <CalendarHeaderCell>
          {intl.formatMessage({ id: 'Load.MailupCommon.Monday' })}
        </CalendarHeaderCell>
        <CalendarHeaderCell>
          {intl.formatMessage({ id: 'Load.MailupCommon.Tuesday' })}
        </CalendarHeaderCell>
        <CalendarHeaderCell>
          {intl.formatMessage({ id: 'Load.MailupCommon.Wednesday' })}
        </CalendarHeaderCell>
        <CalendarHeaderCell>
          {intl.formatMessage({ id: 'Load.MailupCommon.Thursday' })}
        </CalendarHeaderCell>
        <CalendarHeaderCell>
          {intl.formatMessage({ id: 'Load.MailupCommon.Friday' })}
        </CalendarHeaderCell>
        <CalendarHeaderCell>
          {intl.formatMessage({ id: 'Load.MailupCommon.Saturday' })}
        </CalendarHeaderCell>
        {days.map(({ day, date, currentMonth, currentDay, isPast }) => (
          <CalendarCell
            key={date}
            day={day}
            dayOfMonth={currentMonth}
            active={!isPast}
            today={currentDay}
            data={date}
            onClick={handleDayClick}
            highlight={selectedDay === date}
          >
            <CalendarDayContent date={date} />
          </CalendarCell>
        ))}
      </Calendar>
    </>
  )
}

export default CalendarView
